<template>
    <div class="tooltip-body__row mute" @click.stop="userMute">
        <template v-if="isMute">
            <BaseIcon :name="'conversation-is-unmute'" size="24"/>        
            <p v-if="longText">{{ $t("Unmute notifications") }}</p>
            <p v-else>{{ $t("Unmute") }}</p>
        </template>
        <template v-else>
            <BaseIcon :name="'conversation-is-mute'" size="24"/>
            <p v-if="longText">{{ $t("Mute notifications") }}</p>
            <p v-else>{{ $t("Mute") }}</p>
        </template>
    </div>
  </template>
  <script>
  import axios from '/webpack-assets/vue/config/axios-config';
  import BaseIcon from '/webpack-assets/vue/components/BaseIcon.vue';

  export default {
    components: {
      BaseIcon
    },
    data() {
      return {
        isMute: this.isUserMute
      };
    },
    props: {
        userId: {
            type: String,
            default: null,
        },
        longText: {
            type: Boolean,
            default: true
        },
        isUserMute: {
            type: Boolean,
            default: null
        }
    },
    methods: {
      async userMute() {
        this.isMute = !this.isUserMute
        const uuid = this.userId
        this.$emit('user-mute', uuid, this.isMute);
        try {
            const response = await axios.post('/chat-api/switch-conversation-notification', { uuid }, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'multipart/form-data'
                }
            });

            // if (response.data?.status === 'success') {
            //   console.log(response.data?.data)
            //   this.$emit('user-mute', uuid, response.data.data === 'off');
            // }
        } catch (error) {
            console.error('Request failed:', error);
        }
      },
    },
    watch: {
        isUserMute(){
            this.isMute = this.isUserMute
        }
    }
  };
  </script>

<style lang="scss" scoped>
.tooltip-body{
    opacity: 0;
    border-radius: 4px;
    transition: 0.3s;
    pointer-events: none;
    position: absolute;
    top: 40px;
    right: -10px;
    z-index: 15;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
    background: var(--wc-surface-2);
    min-width: 300px;
    &::before{
      content: "";
      position: absolute;
      right: 16px;
      top: -6px;
      width: 12px;
      height: 12px;
      background: var(--wc-surface-2);
      -webkit-transform: rotateZ(45deg);
      transform: rotateZ(45deg);
      z-index: -1;
    }
    &::after{
      content: '';
      position: absolute;
      top: -40px;
      height: 40px;
      width: 40px;
      right: 0;
      @media only screen and (max-width: 1023px) {
        content: none;
      }
    }
    &__row{
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 12px 20px;
      transition: 0.3s;
      &:first-child{
        border-radius: 4px 4px 0 0;
      }
      &:last-child{
        border-radius: 0 0 4px 4px;
      }
      &:hover{
        background: var(--wc-bg);
      }
      svg{
        width: 16px;
        height: 16px;
        min-width: 16px;
        color: var(--wc-text-2);
      }
      p{
        margin: 0;
        font-family: var(--wc-font);
        font-weight: 400;
        font-size: 13px;
        white-space: nowrap;
        line-height: 18px;
        color: var(--wc-text);
      }
    }
  }
</style>